module.exports = __webpack_public_path__ + "img/kuchynka_1.38e06976.jpg";